<template>
  <div>
    <Card>
      <Row>
        <Col span="2" >
          <Button type="info" @click="add">{{$t('pages_banners_index_178')}}</Button>
        </Col>
        <Col span='22'>{{$t('pages_materials_index_614')}}<i-input v-model="setting.material_alias_name" style="max-width: 120px;margin-left:10px" @on-blur="change_material_alias_name" :placeholder="$t('pages_materials_index_614')"></i-input></Col>
      </Row>
      <TablePaginate :columns="columns"
                     :data="materials"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_materials_index_615')">
      <Form ref="material"
            :model="form"
            :label-width="80">
        <Form-item :label="$t('pages_materials_index_616')"
                   prop="title">
          <Input type="text"
                 :placeholder="$t('pages_materials_index_617')"
                 v-model="form.name" />
        </Form-item>
        <Form-item :label="$t('pages_combo_index_282')"
                   prop="price">
          <Input type="number"
                 v-model="form.price" />
        </Form-item>
      </Form>
    </Modal>
    <sync-data-shop ref="syncDataShop" @sync="syncToSubShop" />
    <sync-data-shops ref="syncDataShops" @sync="syncToSubShops" />
  </div>
</template>
<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { syncShopsButtonInTable, deleteButtonInTable, editorButtonInTable, formatDateTime } from '@/libs/table-render'
import SyncDataShop from '@/components/sync-data-shop/index'
import SyncDataShops from '@/components/sync-data-shop/multiple'

export default {
  components: {
    TablePaginate,
    SyncDataShop,
    SyncDataShops
  },
  watch: {
    material (val) {
      if (val && val.id) {
        this.form = val;
      }
    }
  },
  data () {
    return {
      form: {
        name: '',
        price: ''
      },
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_materials_index_616'),
          key: 'name',
        },
        {
          title: i18n.t('pages_combo_index_282'),
          key: 'price',
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at',
          align: 'center',
          render: (h, params) => formatDateTime(h, params.created_at)
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 300,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            if (localStorage.getItem('IS_CLONED_MAIN_SHOP') === '1') {
              // children.push(syncButtonInTable(this, h, params))
              children.push(syncShopsButtonInTable(this, h, params))
            }
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.display()
  },
  computed: {
    ...mapGetters('material', ['material', 'materials', 'meta', 'loading']),
    ...mapGetters('setting', ['setting']),
  },
  methods: {
    ...mapActions('setting', ['display', 'upgrade']),
    ...mapActions('material', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'syncToSubShop',
      'syncToSubShops'
    ]),
    ...mapMutations('material', ['changeQuery', 'targetSyncId']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.form = {}
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.form)
      } else if (this.formType === 'new') {
        await this.create(this.form)
        await this.index()
      }
      this.modalShow = false
    },
    change_material_alias_name () {
      this.upgrade({ material_alias_name: this.setting.material_alias_name })
    },
  }
}
</script>
